import { render } from "./AppBanner.vue?vue&type=template&id=27162b34&scoped=true"
import script from "./AppBanner.vue?vue&type=script&lang=js"
export * from "./AppBanner.vue?vue&type=script&lang=js"

import "./AppBanner.vue?vue&type=style&index=0&id=27162b34&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\cazino\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27162b34"]])

export default __exports__